export const environment = {
  feedbackCategoryLevels: ['group', 'description', 'service_code'] as const,
  privacyPolicyUrl: 'https://kartta.lappeenranta.fi/eFeedback/fi/PrivacyPolicy',
  production: true,
  pushApiUrl: 'https://baltfloods-api.prod.appadem.in/push',
  scheduledMessagesApiUrl: 'https://baltfloods-api.prod.appadem.in/messages',
  radarApiKey: 'your_secret_key',
  sentryDsn: 'your_secret_key',
  serviceApiApiKey: 'your_secret_key',
  serviceApiJurisdictionId: 'citizenapp',
  serviceApiUrl: 'https://baltfloods-api.prod.appadem.in/service-api',
  observationApiUrl: 'https://baltfloods-api.prod.appadem.in/observation',
  pocketbaseUrl: 'https://baltfloods-api.prod.appadem.in/api',
  streetAiApiJurisdictionId: 'lappeenranta',
  streetAiApiKey: 'your_secret_key',
  streetAiApiUrl: 'https://baltfloods-api.prod.appadem.in/street-ai',
  streetAiUploadUrl: 'https://baltfloods-api.prod.appadem.in/uploads',
  intotoEnabled: false,
  intoToApiUrl: 'https://api.intoto.io/api/v1',
  intoToApiKey: 'api-key-goes-here',
  termsOfUseUrl: 'https://kartta.lappeenranta.fi/eFeedback/fi/TermsOfUse',
  trackingCode: 'your_secret_key',
  vapidPublicKey: 'your_public_vapid_key'
};
